import supportedBrowsers from "./supportedBrowsers.jsx";

const iosWebKitBrowserTokens = ["CriOS", "EdgiOS"];

const isIosWebKitBrowser = userAgent =>
  iosWebKitBrowserTokens.some(token => new RegExp(`\\b${token}/\\d`).test(userAgent));

const isSupportedBrowser = (userAgent = navigator.userAgent) =>
  supportedBrowsers.test(userAgent) || isIosWebKitBrowser(userAgent);

export default isSupportedBrowser;
